import { type FC } from 'react';
import {
  Layout
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconLayoutProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconLayout: FC<UiIconLayoutProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Layout}
      {...props}
    />
  );
};
